import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useRelationshipDiscoverer, useFormatter } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

import JSONPretty from 'react-json-pretty'

const dataProviderName = 'cars/trace-km';
const model = 'cars/traceKm';
const modelExposedName = 'Traces';
const wizardAction = 'create';

const Create = (params) => {
    const { t } = useTranslation();
    const { formatDate, formatDistance } = useFormatter();
    const { userCapabilities } = useContext(AppContext);
    const [drawable, setDrawable] = useState(false);
    const [carLoadedInvoked, setCarLoadedInvoked] = useState(false);

    const { doAction, item, loadOne, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const { loadOne: loadOneCar, item: carLoaded, success: successCarLoaded } = useDataProvider('cars/car');

    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.inverseRelation, params?.detailStack?.stack);

    const [car, setCar] = useState();
    const [legalEntity, setLegalEntity] = useState(discover('legalEntity'))

    useEffect(() => {
        const car = discover('car');
        const legalEntity = discover('legalEntity');
        const carId = discover('carId');

        console.info('--------- ');
        console.info('effect base | discovers: ', 'car:', car, 'le:', legalEntity, 'carId:', carId, '| PARAMS', params);

        if (car && legalEntity) {
            // console.info('1) Ho la car e posso procedere', car.plate)
            setCar(car);
            setLegalEntity(legalEntity);
            loadOne(null).then(e => setDrawable(true));
        } else if (!car?.id && carId) {
            // console.info('2) Devo caricare per carId', carId)
            loadOne(null);
            loadOneCar(carId);
            setCarLoadedInvoked(true);
        }
    }, []);

    useEffect(() => {
        if (!carLoaded?.data || !carLoadedInvoked) return;
        // console.info('3) È arrivata la carLoaded', car, carLoaded?.data)

        setCar(carLoaded?.data);

        if (!legalEntity) {
            setLegalEntity(carLoaded?.data.legalEntity)
        };

        setDrawable(true);
    }, [carLoaded]);

    const detailConfig = {
        "tabs": [
            {
                "name": "create_new_trace_km",
                "fieldsets": [
                    {
                        "name": "vehicle_information",
                        "fields": {
                            "car": {
                                "type": "relationshipSingle",
                                "required": true,
                                "relation": {
                                    "drawerRoute": "cars",
                                    "inverseRelation": "traceKm",
                                    "inverseRelationType": "relationshipSingle"
                                },
                                "view": "car"
                            },
                            "legalEntity": {
                                "type": "relationshipSingle",
                                "required": true,
                                "relation": {
                                    "drawerRoute": "legalentities",
                                    "inverseRelation": "traceKm",
                                    "inverseRelationType": "relationshipSingle",
                                    "filter": {
                                        "items": [
                                            {
                                                "field": "type",
                                                "operator": "equals",
                                                "value": "customer"
                                            }
                                        ]
                                    }
                                },
                                "view": "legalEntity"
                            },
                        }
                    },
                    {
                        "name": "trace_data",
                        "fields": {
                            "value": {
                                "type": "number",
                                "required": true,
                                "className": "col-6",
                                "placeholder": "insert",
                                "icon": "faRoad",
                                "label": "value 1"
                            },
                            "traced_at": {
                                "type": "date",
                                "required": true,
                                "className": "col-6",
                                "placeholder": "insert",
                                "icon": "faCalendarStar",
                                "label": "tracing date 1"
                            }
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    let numberOfTrackFields = params.numberOfTrackFields;
    if (!numberOfTrackFields) numberOfTrackFields = 10;
    for (let i = 2; i <= numberOfTrackFields; i++) {
        detailConfig.tabs[0].fieldsets[1].fields["value" + i] = {
            "type": "number",
            "required": true,
            "className": "col-6",
            "placeholder": "insert",
            "icon": "faRoad",
            "label": "value " + i
        }

        detailConfig.tabs[0].fieldsets[1].fields["traced" + i + "_at"] = {
            "type": "date",
            "required": true,
            "className": "col-6",
            "placeholder": "insert",
            "icon": "faCalendarStar",
            "label": "tracing date " + i
        }
    }


    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <>
                <DetailComponent
                    disableDetailConfigOverride={true}
                    values={{
                        ...item?.data,
                        car: car,
                        legalEntity: legalEntity
                    }}
                    modelName={model.split('/')[1]}
                    detailConfig={detailConfig}
                    dataProviderName={dataProviderName}
                    onEditing={setEditing}
                    save={handleSave}
                    saving={saving}
                    errors={errors}
                    errorMessage={errorMessage}
                    title={t('New {{itemname}}', { itemname: t(modelExposedName) })}
                    canSave={userCapabilities && userCapabilities[dataProviderName + '.create']}
                    header={
                        <InfoHeader
                            view="wizard"
                            title={t('Create new {{itemname}}', { itemname: t(modelExposedName) })}
                            subtitle={
                                params.traceKmsLast ?
                                    t('Fill the basic information to create a new {{itemname}}. Last trace ({{lasttracevalue}}) has been recorded at {{lasttracedate}}', { itemname: t(modelExposedName), lasttracevalue: formatDistance(params.traceKmsLast.value), lasttracedate: formatDate(params.traceKmsLast.traced_at) })
                                    :
                                    t('Fill the basic information to create a new {{itemname}} that you will be able to edit via the standard interface', { itemname: t(modelExposedName) })
                            }
                        />
                    }
                    {...params}
                />
            </>
    )
}

export default Create;